import React from 'react'
import { Link } from 'react-router-dom'

function NavBtns({ className, title, link, external, badge, ...props }) {
    const linkClass = `text-white font-body font-medium text-base transition-all duration-200 hover:text-white hover:underline underline-offset-4 cursor-pointer opacity-90 hover:opacity-100 ${className || ''}`;

    const content = (
        <>
            {title}
            {badge && (
                <span className="relative inline-block ml-1">
                    <span className="absolute -top-8 -right-6 px-2 py-0.5 text-xs font-bold bg-red-500 text-white rounded-full whitespace-nowrap">
                        {badge}
                    </span>
                </span>
            )}
        </>
    );

    if (external) {
        return (
            <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={linkClass}
            >
                {content}
            </a>
        );
    }

    return (
        <Link
            to={link}
            className={linkClass}
        >
            {content}
        </Link>
    );
}

export default NavBtns